import Button from "Common/Components/ButtonComponent/Button";

const NormalBannerSegmentCard = ({
    index,
    buttonData,
    handleInputChange,
    errors,
    buttons,
    removeButton,
    isEditable,
    isLoading,
    pageId,
    segmentId,
    toggleLink,
    setIndex,
    setDynamicLink
}) => {
    return (
        <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
                <label className="inline-block mb-2 text-base font-medium">
                  Label
                </label>
                <input
                  type="text"
                  value={buttonData?.label}
                  onChange={isEditable ? (e) =>
                    handleInputChange(index, "label", e.target.value)
                  : null}
                  className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Enter Label"
                />
                {errors && errors.buttons && errors?.buttons[index]?.label && (
                  <p className="mt-2 text-red-500">
                    {errors.buttons[index].label}
                  </p>
                )}
                <div className="flex ">
                  <input
                  disabled={!isEditable}
                    type="text"
                    value={buttonData.value}
                    //disabled={true}
                    onChange={(e) =>
                      handleInputChange(index, "value", e.target.value)
                    }
                    className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Value"
                  />
                  <div
                    onClick={isEditable ? () => {
                      toggleLink();
                      setIndex(index + 1);
                      setDynamicLink("");
                    }: null}
                    className="mb-2 ml-2 text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Addlink
                  </div>
                </div>

                <div className="flex justify-end mt-2">
                  <button
                    onClick={isEditable ? () => removeButton(index) : null}
                    className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  >
                    Remove
                  </button>
                </div>
              </div>
    );
};

export default NormalBannerSegmentCard;
